module.exports = __webpack_public_path__ + "images/assets/95b0da101e04dbdeb3f52a3ce319aab9.svg";